import * as actionTypes from "../action-types";
import { toaster } from '../../utils/services/toast-service';
import { put, takeLeading, delay } from 'redux-saga/effects';
import { AstrologyAPIRequest } from '../../utils/api-function';
import { get_horoscope, get_asthakoota, get_astro_data } from '../../utils/api-routes';

//! Horoscope
export function* getHoroscope(action) {
    try {
        const { payload } = action;
        console.log("Get Horoscope Payload ::: ", payload);
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const data = yield AstrologyAPIRequest(get_horoscope, payload);
        console.log('Horoscope API Response ::: ', data);
        if (data?.success && data?.responseData?.status) {
            const horoscopeData = data?.responseData?.data[0]?.horoscope;
            yield put({
                type: actionTypes.SET_HOROSCOPE,
                payload: {
                    daily: horoscopeData.daily,
                    weekly: horoscopeData.weekly,
                    monthly: horoscopeData.monthly,
                    yearly: horoscopeData.yearly,
                    tags: {
                        daily: horoscopeData?.dailytag,
                        weekly: horoscopeData?.weeklytag,
                        monthly: horoscopeData?.monthlytag,
                        yearly: horoscopeData?.yearlytag
                    }
                }
            });
        } else {
            toaster?.warning({ text: data?.responseData?.message || "Failed to fetch horoscope data!" });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log('Get Horoscope Saga Error :::', error);
        toaster?.error({ text: error.message || 'Something went wrong!' });
    }
};

//! Kundli Matching
export function* getAsthaKoota(action) {
    try {
        const { payload } = action;
        console.log("Get Horoscope Payload ::: ", payload);

        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        yield delay(100);
        const data = yield AstrologyAPIRequest(get_asthakoota, payload);
        console.log('AsthaKoota API Response ::: ', data);

        if (data?.success && data?.responseData?.status) {
            const asthakootaData = data?.responseData?.data[0];
            yield put({
                type: actionTypes.SET_ASTHAKOOTA,
                payload: asthakootaData
            })

        } else {
            toaster?.warning({ text: data?.responseData?.message || "Failed to fetch horoscope data!" });
        }

        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log('Get Horoscope Saga Error :::', error);
        toaster?.error({ text: error.message || 'Something went wrong!' });
    }
};

export function* getAstroData(action) {
    try {
        const { payload } = action;
        console.log("Get AstroData Payload ::: ", payload);

        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        yield delay(100);

        const data = yield AstrologyAPIRequest(get_astro_data, payload);
        console.log('Astro Data API Response ::: ', data);

        if (data?.success && data?.responseData?.status) {
            const astroData = data?.responseData?.data[0];
            yield put({
                type: actionTypes.SET_ASTRO_DATA,
                payload: astroData
            });

        } else {
            toaster?.warning({ text: data?.responseData?.message || "Failed to fetch horoscope data!" });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log('Get Horoscope Saga Error :::', error);
        toaster?.error({ text: error.message || 'Something went wrong!' });
    }
};

export default function* astrologyApiSaga() {
    //! Horoscope 
    yield takeLeading(actionTypes?.GET_HOROSCOPE, getHoroscope);
    //! Kundli Matching
    yield takeLeading(actionTypes.GET_ASTHAKOOTA, getAsthaKoota);
    yield takeLeading(actionTypes.GET_ASTRO_DATA, getAstroData);
};